import { fetchWithToken } from '../fetcher'

const CREATE_COMPARE_LIST = `
mutation createCompareList($input: CreateCompareListInput) {
    createCompareList(input: $input) {
      uid
    }
  }
`
const GET_COMPARE_LIST = `
query compareList($uid: ID!) {
    compareList(uid: $uid) {
      attributes {
        code
        label
      }
      item_count
      uid
      items {
        uid
        product {
          __typename
          sku
          uid
          name
          url_key
          url_suffix
          canonical_url
          stock_status
          image {
            ...ProductImageFields
          }
          thumbnail {
            ...ProductImageFields
          }
          daily_sale {
            end_date
            entity_id
            product_id
            start_date
            sold_qty
            sale_qty
            sale_price
          }
          uid
          new_from_date
          new_to_date
          price_range {
            maximum_price {
              discount {
                amount_off
                percent_off
              }
              final_price {
                ...MoneyFields
              }
              regular_price {
                ...MoneyFields
              }
            }
          }
        }
      }
    }
  }fragment ProductImageFields on ProductImage {
    disabled
    label
    url
    position
  }fragment MoneyFields on Money {
    currency
    value
  }`

const ADD_TO_COMPARE_LIST = `
mutation addProductsToCompareList($input: AddProductsToCompareListInput) {
 addProductsToCompareList(input: $input) {
      item_count
      uid
     }
    }
`

const REMOVE_ITEM_FROM_COMPARE_LIST = `
mutation removeProductsFromCompareList($input: RemoveProductsFromCompareListInput) {
  removeProductsFromCompareList(input: $input) {
    item_count
    uid
  }
}`

const DELETE_COMPARE_LIST = `
mutation deleteCompareList($uid: ID!) {
    deleteCompareList(uid: $uid) {
      result
    }
  }
`

const ASSIGN_COMPARE_LIST = `
mutation assignCompareListToCustomer($uid: ID!) {
     assignCompareListToCustomer(uid: $uid) {
     result
     }
    }
`
const createCompareList = async (listIdProducts: string[]) => {
  try {
    const response = await fetchWithToken({
      query: CREATE_COMPARE_LIST,
      variables: {
        input: {
          products: listIdProducts,
        },
      },
    }).then((res) => res?.payload)
    const compareList = response?.data?.createCompareList
    if (!compareList)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const getCompareList = async (compareUid: string) => {
  try {
    const response = await fetchWithToken({
      query: GET_COMPARE_LIST,
      variables: {
        uid: compareUid,
      },
    }).then((res) => res?.payload)
    // console.log("aaaa", cookies, response);
    const compareList: {
      attributes: any[]
      item_count: number
      uid: string
      items: IVariantsProduct[]
    } = response?.data?.compareList

    if (!compareList)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const addToCompareList = async ({
  listIdProducts,
  compareUid,
}: {
  listIdProducts: string[]
  compareUid: string
}) => {
  try {
    const response = await fetchWithToken({
      query: ADD_TO_COMPARE_LIST,
      variables: {
        input: {
          products: listIdProducts,
          uid: compareUid,
        },
      },
    }).then((res) => res?.payload)
    const compareList: {
      item_count: number
      uid: string
    } = response?.data?.addProductsToCompareList

    if (!compareList || response?.errors?.[0]?.length > 0)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const removeItemFromCompareList = async ({
  listIdProducts,
  compareUid,
}: {
  listIdProducts: string[]
  compareUid: string
}) => {
  try {
    const response = await fetchWithToken({
      query: REMOVE_ITEM_FROM_COMPARE_LIST,
      variables: {
        input: {
          products: listIdProducts,
          uid: compareUid,
        },
      },
    }).then((res) => res?.payload)

    const compareList: {
      item_count: number
      uid: string
    } = response?.data?.removeProductsFromCompareList

    if (!compareList)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const deleteCompareList = async (compareUid: string) => {
  try {
    const response = await fetchWithToken({
      query: DELETE_COMPARE_LIST,
      variables: {
        uid: compareUid,
      },
    }).then((res) => res?.payload)
    console.log('deleteCompareList', response)

    const compareList = response?.data?.deleteCompareList

    if (!compareList)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const assignCompareList = async (compareUid: string) => {
  try {
    const response = await fetchWithToken({
      query: ASSIGN_COMPARE_LIST,
      variables: {
        uid: compareUid,
      },
    }).then((res) => res?.payload)

    const compareList = response?.data?.assignCompareListToCustomer?.result
    if (!compareList)
      return {
        data: null,
        message: response?.errors?.[0]?.message,
        status: 'error',
      }
    return { status: 'success', data: compareList }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}
export {
  createCompareList,
  getCompareList,
  addToCompareList,
  removeItemFromCompareList,
  deleteCompareList,
  assignCompareList,
}
